// @ts-check

/// <reference types="vite/client" />

import { registerAppComponent } from "./app";
import { registerComponent } from "./component";
import { appDirNameFromPath } from "./utils";

// The eager catalog: static, build-time imports of every component and app
// implementation. Importing this module pulls the entire catalog into the
// importer's graph, so it is restricted (ESLint no-restricted-imports) to the
// build-time-selected eager entry implementation, Storybook, and the test
// harness. The lazy build must never reach it — the ce-lazy-purity build
// plugin fails the build if this module enters the lazy entry graph.

/**
 * Registers all components in the components directory.
 *
 * @param {Record<string, unknown>} props - Default values for the component props.
 * @param {Record<string, string[]>} aliases - Aliases for the component names.
 */
export async function registerComponents(props, aliases) {
  /**
   * @type {Record<string, { default: import("vue").DefineComponent }>}
   */
  const components = import.meta.glob("../components/**/Sp*.ce.vue", { eager: true });

  for (const [path, component] of Object.entries(components)) {
    registerComponent(component, path, aliases, props);
  }
}

/**
 * Registers all components in the apps directory.
 *
 * @param {Record<string, unknown>} props - Default values for the component props.
 */
export async function registerAppComponents(props) {
  /**
   * @type {Record<string, import("./app").App>}
   */
  const apps = import.meta.glob("../apps/**/main.js", { eager: true });

  for (const [path, app] of Object.entries(apps)) {
    registerAppComponent(app, appDirNameFromPath(path), props);
  }
}
